<template>
  <div v-wechat-title="titleTop" class="bodyBack">
    <topImg />
    <div class="qrCodeImgBack">
      <img src="/img/boat/qrcodeBack.png">
      <div class="qrCodeImg">
        <img :src="imgRes">
      </div>
    </div>
    <div class="titleLine1">船只预定</div>
    <div class="titleLine2">查询折扣价格<br>请扫码联系酷潜小客服</div>
    <!-- <div class="icpLine">蜀ICP备20019214号-1 成都酷潜文化旅游有限公司</div> -->
    <boatKf/>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import topImg from '@/views/boat/boatTopImgBack.vue'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import  boatKf from '@/views/boat/boatKf.vue'
export default {
  components: {
    [Button.name]: Button,
    topImg,
    boatKf
  },
  data() {
    return {
      titleTop: '酷潜船宿精选',
      imgRes:'',
    }
  },

  created() {
    this.titleTop ='酷潜船宿精选'
    this.initTopRes()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initTopRes(){
      request({
        url: '/DiveBoat/getFollowPage',
        method: 'post',
      }).then(response => {
        if (!response.success) {
          return
        }
        this.imgRes = response.data.qrCode.img
      })
    },
  }
}
</script>
<style>
.bodyBack{
  background-color:#fff;
  min-height:100vh;
  width:100vw;
  overflow-x:hidden;
  text-align:center;
}
.qrCodeImgBack{
  margin-left:25vw;
  width:50vw;
  margin-top:4em;
  position:relative;
}
.qrCodeImgBack img{
  width:100%;
}
.qrCodeImg{
  position:absolute;
  width:84%;
  height:84%;
  left:8%;
  top:6%;
}
.titleLine1{
  font-weight:700;
  margin-top:2em;
  font-size:0.9em;
  color:#333333;
}
.titleLine2{
  margin-top:2em;
  font-size:0.7em;
  color:#777777;
  line-height:2.2em;
}
</style>

